var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "btn",
          attrs: { type: "button", disabled: _vm.disabled },
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c("span", {
            staticClass: "spinner-border spinner-border-sm mr-2",
            attrs: { role: "status", "aria-hidden": "true" },
          })
        : _vm._e(),
      _vm._t("body", function () {
        return [
          _vm._t("body-icon"),
          _vm._t("body-text", function () {
            return [
              _c(
                "span",
                { staticClass: "p-2", class: { uppercase: _vm.uppercase } },
                [_vm._v(_vm._s(_vm.title))]
              ),
            ]
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }